enum DirectoryTabsLayout {
  DESKTOP = 'DESKTOP',
  SOFTPHONE = 'SOFTPHONE',
}

export default DirectoryTabsLayout;
